import aiWriterIcon from './image/ai-writer-icon.svg';
import * as EditorTypeAll from '../tinymce.d';
import { useSupplierAgentActions } from '@/features/supplier-agent/hooks/use-supplier-agent-actions';
import { useChatPageStore } from '@/features/chat-messages/store';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const AIWriter = ({ editorInstance }: Props) => {
  const { handleAiEmailWrite } = useSupplierAgentActions();
  const asking = useChatPageStore(state => state.asking);
  const isLoadingResponse = useChatPageStore(state => state.isLoadingResponse);

  const isDisabled = asking || isLoadingResponse;

  const handleClick = () => {
    if (isDisabled) return;
    editorInstance;
    handleAiEmailWrite();
  };

  return (
    <div
      className="inline-flex items-center gap-[4px] px-[8px] py-[4px] rounded-[8px] flex-shrink-0 "
      style={{
        background: 'linear-gradient(26deg, rgba(234, 249, 221, 1) 0%, rgba(234, 248, 238, 1) 45%, rgba(254, 253, 227, 1) 100%)',
        opacity: isDisabled ? 0.4 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      }}
      onClick={handleClick}
    >
      <img width="20px" height="20px" src={aiWriterIcon} alt="AI Writer" />
      <span
        className="text-sm font-normal leading-[1.5em]"
        style={{
          background: 'linear-gradient(75deg, rgba(4, 96, 85, 1) 7%, rgba(66, 196, 6, 1) 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          letterSpacing: '0.5%',
        }}
      >
        AI Writer
      </span>
    </div>
  );
};

export default AIWriter;
